import React from 'react';
import { Box, useTheme } from '@mui/material';

function CustomInputWithSize({ label, placeholder, type, error, helperText, height, ...props }) {
    const theme = useTheme();

    return (
        <Box>
            <p
                style={{
                    color: theme.palette.text.primary,
                    fontSize: 13,
                    marginTop: 24,
                    marginBottom: 4,
                }}
            >
                {label}
            </p>
            <textarea
                placeholder={placeholder}
                style={{
                    width: '100%',
                    resize: 'none',
                    backgroundColor: theme.palette.customGrey.insideInput,
                    padding: '6px 8px',
                    height: height ? `${height}px` : 'auto',
                    color: theme.palette.text.primary,
                    border: `1px solid ${theme.palette.customGrey.borderInput}`,
                    borderRadius: theme.shape.borderRadius,
                    fontSize: '15px',
                    lineHeight: '1.5',
                    fontFamily: theme.typography.fontFamily,
                    '&::placeholder': {
                        color: theme.palette.text.secondary,
                        opacity: 1,
                    },
                    '&:hover': {
                        borderColor: theme.palette.customGrey.borderInput,
                    },
                    '&:focus': {
                        borderColor: theme.palette.primary.main,
                        outline: 'none',
                    },
                }}
                {...props}
            />
            {error && <p style={{ color: theme.palette.error.main, fontSize: 12, marginTop: 4 }}>{helperText}</p>}
        </Box>
    );
}


export default CustomInputWithSize;
